import { useLocation } from '@/router/navigation'
import { ApplicationFormPage } from '../ApplicationFormPage'
import { CallRequestPage } from '../CallRequestPage'
import { DemographicsPage } from '../DemographicsPage'
import { ScheduleAppointmentPage } from '../ScheduleAppointmentPage'
import { SelfEnrollmentFlowPage } from '../SelfEnrollmentFlowPage'
import { ThankYouPage } from '../ThankYouPage'
import { normalizeInternalEnrollmentPath } from './routes'

export function SponsoredEnrollmentScreenRenderer() {
  const location = useLocation()
  const activePath = normalizeInternalEnrollmentPath(location.pathname)

  switch (activePath) {
    case '/self-enroll':
      return <SelfEnrollmentFlowPage />
    case '/schedule':
      return <ScheduleAppointmentPage />
    case '/endorsements':
      return <DemographicsPage />
    case '/request-call':
      return <CallRequestPage />
    case '/thank-you':
      return <ThankYouPage />
    case '/application':
    default:
      return <ApplicationFormPage />
  }
}
